import(/* webpackMode: "eager" */ "/codebuild/output/src2672261643/src/auto-playlist/frontend/src/app/global-error.tsx");
